<template>
  <div class="wrapper-call">
    <div>
      <h1>Você costuma fazer ligações?</h1>
    </div>
    <div class="container">
      <div>
        <button
          v-for="option in call"
          :class="{ btnsel: option.id == selected }"
          @click="
                        selected = option.id;
                        selectedProduct = option.product;
                        addPlan();
                    "
          v-bind:key="option.id"
          class="btn-calls item"
        >{{ option.name }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calls",
  props: ["points", "range"],
  data() {
    return {
      yourPlan: "",
      selected: undefined,
      selectedProduct: undefined,
      call: [
        {
          name: "Para fixo local",
          id: 0,
          point: this.points[18].item_points,
          product: this.points[18].item_name
        },
        {
          name: "Para fixo e celular local",
          id: 1,
          point: this.points[19].item_points,
          product: this.points[19].item_name
        },
        {
          name: "Para fixo nacional e celular local",
          id: 2,
          point: this.points[20].item_points,
          product: this.points[20].item_name
        },
        {
          name: "Para fixo e celular local e nacional",
          id: 3,
          point: this.points[21].item_points,
          product: this.points[21].item_name
        }
      ]
    };
  },
  methods: {
    addPlan() {
      this.$store.commit("ADD_PLAN_TWO", this.selectedProduct);
    }
    // fetchPoints() {
    //     fetch("http://localhost:3333/config_items")
    //         .then(r => r.json())
    //         .then(r => {
    //             const parseobj = JSON.parse(JSON.stringify(r));
    //             console.log(parseobj);
    //             this.points = parseobj;
    //         });
    // }
  },
  created() {
    const result =
      this.$store.state.multiplan +
      this.$store.state.multiplantwo * this.$store.state.plan;
    if (
      result >= this.range[0].min_poits &&
      result <= this.range[0].max_points
    ) {
      this.yourPlan = "200";
    } else if (
      result >= this.range[1].min_poits &&
      result <= this.range[1].max_points
    ) {
      this.yourPlan = "300";
    } else if (
      result >= this.range[2].min_poits &&
      result <= this.range[2].max_points
    ) {
      this.yourPlan = "400";
    } else if (
      result >= this.range[3].min_poits &&
      result <= this.range[3].max_points
    ) {
      this.yourPlan = "500";
    } else if (
      result >= this.range[4].min_poits &&
      result <= this.range[4].max_points
    ) {
      this.yourPlan = "750";
    } else if (
      result >= this.range[5].min_poits &&
      result <= this.range[5].max_points
    ) {
      this.yourPlan = "1000";
    } else {
      this.yourPlan = "200";
    }
    this.$store.commit("ADD_PLAN_RESULT", this.yourPlan);
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";

.wrapper-call {
  padding: 1em;
  display: flex;
  align-items: center;
}

.container {
  margin: 0 auto;
  text-align: right;
}

.item {
  text-align: center;
  font-size: 1.5em;
  margin-right: 45px;
  margin-bottom: 15px;
}

.btn-calls {
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #6d4a914d;
  border-radius: 20px;
  width: 415px;
  height: 58px;
  text-align: left;
  font-weight: Bold;
  font-size: 14px;
  color: $light-orange;
  padding-left: 44px;
  text-transform: uppercase;
  cursor: pointer;
}

.btn-calls:hover {
  box-shadow: 0px 0px 10px #6d4a914d;
}

.btnsel {
  border: 4px solid #ffa25086;
  background: $purple 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #4605894d;
  color: $white;
}

h1 {
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  color: $light-orange;
  width: 8em;
}

@media only screen and (max-width: 600px) {
  .wrapper-call {
    padding: 1em;
    flex-direction: column;
    margin-bottom: 3em;
  }

  h1 {
    border-bottom: 0;
    padding-bottom: 2em;
  }

  .item {
    margin-bottom: 3em;
  }

  .btn-calls {
    width: 100% !important;
    text-align: center;
    font-size: 12px;
    padding: 14px;
  }
}

@media only screen and (max-width: 1280px) {
  .btn-calls {
    width: 75%;
    padding: 1.5em;
    font-size: 13px;
  }

  .item {
    margin-right: 0px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  h1 {
    width: 40%;
  }
}
</style>
